var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateLoadStatus3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.132 13.192c-.344 0-.696-.072-1.056-.216a2.843 2.843 0 01-.984-.672 2.769 2.769 0 01-.624-1.164l.924-.384c.128.464.344.824.648 1.08a1.67 1.67 0 001.092.384c.304 0 .588-.064.852-.192a1.61 1.61 0 00.624-.552c.16-.24.24-.504.24-.792 0-.28-.08-.536-.24-.768a1.507 1.507 0 00-.636-.54 1.884 1.884 0 00-.876-.204h-.708v-.948h.636c.44 0 .808-.124 1.104-.372.296-.256.444-.592.444-1.008 0-.384-.144-.692-.432-.924-.288-.232-.644-.348-1.068-.348-.416 0-.744.108-.984.324-.232.216-.4.48-.504.792l-.936-.396c.144-.432.42-.82.828-1.164.416-.352.948-.528 1.596-.528.48 0 .912.096 1.296.288.384.192.684.46.9.804.224.344.336.728.336 1.152 0 .424-.108.784-.324 1.08a2.318 2.318 0 01-.804.696v.048c.408.168.744.428 1.008.78.264.344.396.752.396 1.224 0 .48-.124.912-.372 1.296-.24.384-.572.684-.996.9a2.95 2.95 0 01-1.38.324zm7.226-8.784h.948L7.742 13h-.948l3.564-8.592zm5.087 6.828h-3.936v-.768l3.84-5.676h1.104v5.484h1.056v.96h-1.056V13h-1.008v-1.764zm0-.96V6.28h-.048l-2.724 3.996h2.772z",
    fill: "#9390A0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#07AFF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#07AFF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#07AFF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateLoadStatus3);
export default __webpack_public_path__ + "static/media/create-load-status-3.dd2da2b7f8f552846cb7db39f65cd11b.svg";
export { ForwardRef as ReactComponent };